import { IAppState } from '../../common/state';

export function selectPaginationUrls(state: IAppState): string[] {
  return state.results.paginationUrls;
}
